module.exports = __webpack_public_path__ + "static/media/indexacapital--background.3cdc3ec3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pages/porfolio/indexacapital/indexacapital--background.jpg
// module id = 180
// module chunks = 0